import React, { useState, useEffect, useRef } from "react";
import { History as HistoryIcon } from "lucide-react";
import Feedback01 from "./Feedback01";
import Feedback02 from "./Feedback02";
import Feedback03 from "./Feedback03";
import FeedbackHistory from "./FeedbackHistory";
import useFetch from "../../hooks/useFetch";
import { ReactComponent as Cross } from "../../assets/images/svg/Cross.svg";
import { FEEDBACK } from "../../utils/ApiUrls";
import { TopDisappearingMessage } from "../../utils/Common";
import useAuth from "../../hooks/useAuth";
import useSocket from "../../hooks/useWebsocket";

const STEPS = [
  { key: "Feedback01", label: "Customer Info" },
  { key: "Feedback02", label: "Feedback" },
  { key: "Feedback03", label: "Follow-up" },
];


const CallFeedback = (props) => {
  console.log("**************************************  CALL DATA  *****************************************")
  console.log(JSON.stringify(props))
  console.log("**************************************  CALL DATA  *****************************************")
  const [curfback, setcurrfback] = useState("Feedback01");
  const FBdata = props.FBdata;
  const setFBdata = props.setFBdata;
  const fetchData = useFetch();
  const { auth } = useAuth();
  const [isReady, val, send] = useSocket();
  const [editfbpermission, seteditfbpermission] = useState(false);
  const stepBeforeHistoryRef = useRef("Feedback01");

  const toggleHistory = () => {
    if (curfback === "History") {
      setcurrfback(stepBeforeHistoryRef.current);
    } else {
      stepBeforeHistoryRef.current = curfback;
      setcurrfback("History");
    }
  };
  console.log("Feedback js   customer data    :    ", props.customer);
  
  // state
  const [agentPicker, setAgentPicker] = useState(null); // { agents, recent }
  const [selectedAgent, setSelectedAgent] = useState(null); // { id, name }

  const [agentSearch, setAgentSearch] = useState("");
  const [onlyCampaign, setOnlyCampaign] = useState(false);

  const filteredAgents = (agentPicker?.agents || []).filter(
    (a) =>
      (a.AgentName || "").toLowerCase().includes(agentSearch.trim().toLowerCase()) &&
      (!onlyCampaign || a.AgentInCmpaign)
  );

  useEffect(() => {
    setcurrfback("Feedback01");
  }, [props.call_id]);

  useEffect(() => {
    if (auth?.user_details?.type === "agent") {
      seteditfbpermission(true);
    } else {
      seteditfbpermission(true);
    }
  }, []);

  useEffect(() => {
    const data = val?.data || { callstatus: "" };
    const action = val?.action;
    console.log("Feedback Value ---->  : ", val)
    console.log("Feedback Data ---->  : ", data)
    console.log(
      typeof data.closeInSeconds,
      "Feedback Hide Tiem --------------------------------->   : ",
      data.closeInSeconds
    );
    if (props.camp_data.campaign_mode == "auto") {
      if (data.callstatus == "end") {
        TopDisappearingMessage(
          "top-start",
          data.closeInSeconds,
          "warning",
          "Next customer in " + data.closeInSeconds + " seconds"
        );

        // setTimeout(function () {
        //   // submitData();
        //   props.setfback(false);
        //   console.log("Send socket message next call auto")
        //   send(
        //     JSON.stringify({
        //       type: "feedback_close",
        //       next_call : true,
        //     })
        //   );

        // }, parseInt(data.closeInSeconds) * 1000);
      }
    }
  }, [val]);

  const CloseFB = () => {
    props.setfback(false);
    props.close(false);
  };

  console.log("before submit feedback customer ---------------->  ", props.customer)

  const doSubmit = async (agentOverrideId) => {
    let user_id;

    const feedbackRequired =
      auth?.user_details?.feedback_required_before_next_call === true ||
      auth?.user_details?.feedback_required_before_next_call === "true";
      
    if (agentOverrideId) {
      user_id = agentOverrideId;
    } else if (auth?.user_details?.type == "agent") {
      user_id = auth?.user_details?.contact_agent_id || 0;
    } else {
      user_id = props.FBdata.agent_id || 0;
    }

    if (!feedbackRequired && user_id) {
      console.log("[___] Feedback is not required action is call customer. feedbackRequired: ",feedbackRequired)
      props.setfback(false);
      props.close(false);
      if (props.setFeedbackSubmitted != undefined) {
        props.setFeedbackSubmitted(true);
      }
      if (props.setIsCallEnded != undefined) {
        props.setIsCallEnded(false);
      }
    }


    let customer_data = props.customer;
    if (props.customer.id == undefined) {
      customer_data = localStorage.getItem("customer");
    }

    const url = FEEDBACK + user_id + "/" + customer_data.id + "/";
    const payloadToSend = {
      ...FBdata,
      agent_id: user_id,
      customer_id: customer_data.id,
    };

    const res_data = await fetchData("post", payloadToSend, url);

    if (res_data?.data == "success") {
      window.dispatchEvent(new Event("refresh-followups"));
      console.log(props.campaignRepotData, ">>>>>>>>>>>>>>>>>>>>>>>>>>>>>>");
      setAgentPicker(null);
      props.setfback(false);
      props.close(false);
      if (props.setFeedbackSubmitted != undefined) {
        props.setFeedbackSubmitted(true);
      }

      if (props.campaignRepotData != undefined) {
        const updatedData = props.campaignRepotData.map((item) => {
          if (item && props.FBdata && item.call_uid === props.FBdata.uid) {
            return {
              ...item,
              call_feedback:
                item.call_feedback === null ? res_data?.id : item.call_feedback,
            };
          }
          return item;
        });
        props.setCampaignReportData(updatedData);
      }

      setFBdata((prevState) => {
        return { ...prevState, id: res_data?.id };
      });
      if (feedbackRequired) {
        props.setfback(false);
        props.close(false);
        console.log("[___] Feedback submitted. feedbacksubmitted : ", props.feedbacksubmitted)
        // if (props.setFeedbackSubmitted != undefined) {
        props.setFeedbackSubmitted(true);
        if (props.setIsCallEnded != undefined) {
          props.setIsCallEnded(false);
          console.log("setIsCallEnded :",false)
        }
      }
      if (
        FBdata.dnc && props.camp_data?.campaign_mode === "manual"
      ) {
        setFBdata({
          id: "0",
          uid: "",
          agent_id: "",
          customer_id: "",
          answers: {},
          fbanswer: {},
          comment: "",
          folloup: "",
          dnc: false,
          fdbk_close: false,
        });
        if (!props.call_id && typeof props.showNextCustomer === "function") {
          props.showNextCustomer(3);
        }
      }
      TopDisappearingMessage(
        "top-start",
        2000,
        "success",
        "Successfully submited the feedback",
        true
      );

      const campDetails = localStorage.getItem("camp_details");

      //if campaign stops during a call , check camp_details is empty if its empty, close feedback popup
      if (campDetails && campDetails !== "{}") {
        console.log("camp_details available");
      } else {
        console.log("camp_details not available");
        props.setCall((prev) => ({
          ...prev,
          showcall: null,
        }));
      }

    } else if (res_data?.data === "agent_selection") {
      setSelectedAgent(null);
      setOnlyCampaign(false);
      setAgentSearch("");
      setAgentPicker({
        agents: res_data.agents_under_admin_serialized || [],
        recent: res_data.recent_10_call_records_serialized || [],
      });
    } else {
      alert("Error in Updating the agent status");
    }
  };

  const submitData = () => doSubmit();

  const questionArray = props?.camp_data?.questionArray || [];
  const hasQuestions = questionArray.length > 0;
  const steps = hasQuestions ? STEPS : STEPS.filter((step) => step.key !== "Feedback02");
  const activeStepIndex = steps.findIndex((step) => step.key === curfback);

  const PersonIcon = ({ className = "h-3.5 w-3.5 text-orange-600" }) => (
    <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="8" r="4" />
      <path d="M4 20c0-4 4-6 8-6s8 2 8 6" />
    </svg>
  );

  const CallIcon = ({ className = "h-3.5 w-3.5 text-green-600" }) => (
    <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.8 19.8 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 2.12 4.18 2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.36 1.9.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.91.34 1.85.57 2.81.7A2 2 0 0 1 22 16.92z" />
    </svg>
  );

  return (
    <div
      id="defaultModal"
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4"
    >
      <div className="flex max-h-[90vh] w-full max-w-2xl flex-col overflow-hidden rounded-2xl bg-white shadow-2xl">
        {/* Header */}
        <div className="flex items-center justify-between border-b border-gray-100 px-6 py-4">
          <h1 className="text-lg font-bold text-gray-900">Call Feedback</h1>
          <div className="flex items-center gap-1">
            <button
              type="button"
              className={`flex h-8 items-center gap-1.5 rounded-full px-3 text-xs font-semibold transition-colors ${
                curfback === "History"
                  ? "bg-blue-50 text-blue-600"
                  : "text-gray-400 hover:bg-gray-100 hover:text-gray-600"
              }`}
              onClick={toggleHistory}
              title="Feedback history"
            >
              <HistoryIcon className="h-3.5 w-3.5" />
              History
            </button>
            <button
              type="button"
              className="flex h-8 w-8 items-center justify-center rounded-full text-gray-400 transition-colors hover:bg-gray-100 hover:text-gray-600"
              onClick={CloseFB}
              title="Close"
            >
              <Cross className="h-4 w-4" />
            </button>
          </div>
        </div>


        {/* popup: render inside the outer #defaultModal div, after the inner card */}
        {agentPicker && (
          <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/50 p-4">
            <div className="flex max-h-[85vh] w-full max-w-3xl flex-col overflow-hidden rounded-2xl bg-white shadow-2xl">
              <div className="flex items-center justify-between border-b border-gray-100 px-6 py-4">
                <h2 className="text-base font-bold text-gray-900">Select Agent</h2>
                <button
                  type="button"
                  className="flex h-8 w-8 items-center justify-center rounded-full text-gray-400 hover:bg-gray-100"
                  onClick={() => setAgentPicker(null)}
                >
                  <Cross className="h-4 w-4" />
                </button>
              </div>

              {/* selected agent input (fixed) */}
              <div className="px-6 pt-5">
                <label className="mb-1 block text-xs font-medium text-gray-500">
                  Selected Agent
                </label>
                <input
                  type="text"
                  readOnly
                  value={selectedAgent?.name || ""}
                  placeholder="Click an agent below"
                  className="w-full rounded-lg border border-gray-200 px-3 py-2 text-sm"
                />
              </div>

              {/* two columns */}
              <div className="grid min-h-0 flex-1 grid-cols-1 gap-4 px-6 py-5 md:grid-cols-2">
                {/* all agents */}
                <div className="flex min-h-0 flex-col">
                  <div className="flex items-center justify-between">
                    <h3 className="mb-2 text-xs font-semibold uppercase text-gray-500">All agents</h3>
                    <button
                      type="button"
                      onClick={() => setOnlyCampaign((v) => !v)}
                      className="flex items-center gap-2 text-xs text-gray-600"
                    >
                      <span>In campaign only</span>
                      <span
                        className={`relative inline-block h-4 w-7 rounded-full transition-colors ${
                          onlyCampaign ? "bg-[#6BC698]" : "bg-gray-300"
                        }`}
                      >
                        <span
                          className={`absolute top-0.5 h-3 w-3 rounded-full bg-white transition-all ${
                            onlyCampaign ? "left-3.5" : "left-0.5"
                          }`}
                        />
                      </span>
                    </button>
                  </div>
                  <input
                    type="text"
                    value={agentSearch}
                    onChange={(e) => setAgentSearch(e.target.value)}
                    placeholder="Search agent"
                    className="mb-2 w-full rounded-lg border border-gray-200 px-3 py-2 text-sm focus:border-[#6BC698] focus:outline-none"
                  />
                  <div className="max-h-[37.8vh] flex-1 overflow-y-auto rounded-lg border border-gray-100 p-2">
                    {filteredAgents.length === 0 ? (
                      <p className="p-2 text-sm text-gray-400">No agents found</p>
                    ) : (
                      <ul className="space-y-1">
                        {filteredAgents.map((a) => (
                          <li
                            key={a.Agent_id}
                            onClick={() => setSelectedAgent({ id: a.Agent_id, name: a.AgentName })}
                            className={`flex cursor-pointer items-center gap-2 rounded-lg border px-3 py-2 text-sm hover:bg-gray-50 ${
                              selectedAgent?.id === a.Agent_id ? "border-[#6BC698] bg-green-50" : "border-gray-100"
                            }`}
                          >
                            <PersonIcon />
                            <span className="flex-1">{a.AgentName}</span>
                            {a.AgentInCmpaign && (
                              <span className="text-[10px] font-semibold text-green-600">In campaign</span>
                            )}
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                </div>

                {/* recent */}
                <div className="flex min-h-0 flex-col">
                  <h3 className="mb-2 text-xs font-semibold uppercase text-gray-500">
                    Recently talked to this customer
                  </h3>
                  <div className="max-h-[45vh] flex-1 overflow-y-auto rounded-lg border border-gray-100 p-2">
                    {agentPicker.recent.length === 0 ? (
                      <p className="p-2 text-sm text-gray-400">No recent calls</p>
                    ) : (
                      <ul className="space-y-1">
                        {agentPicker.recent.map((r, i) => (
                          <li
                            key={i}
                            onClick={() =>
                              r.Agent_id && setSelectedAgent({ id: r.Agent_id, name: r.AgentName })
                            }
                            className={`flex cursor-pointer items-center gap-2 rounded-lg border px-3 py-2 text-sm hover:bg-gray-50 ${
                              selectedAgent?.id === r.Agent_id ? "border-[#6BC698] bg-green-50" : "border-gray-100"
                            }`}
                          >
                            <CallIcon />
                            <span className="flex-1">{r.AgentName}</span>
                            {r.AgentInCmpaign && (
                              <span className="rounded-full bg-green-50 px-2 py-0.5 text-[10px] font-semibold text-green-600">
                                In campaign
                              </span>
                            )}
                            <span className="text-xs text-gray-400">{r.CalledTime}</span>
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                </div>
              </div>

              <div className="flex justify-end gap-2 border-t border-gray-100 px-6 py-4">
                <button
                  type="button"
                  className="rounded-lg px-4 py-2 text-sm text-gray-600 hover:bg-gray-100"
                  onClick={() => setAgentPicker(null)}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  disabled={!selectedAgent}
                  onClick={() => doSubmit(selectedAgent.id)}
                  className="rounded-lg bg-[#6BC698] px-4 py-2 text-sm font-semibold text-white disabled:opacity-40"
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Step indicator */}
        {curfback !== "History" && (
        <div className="flex items-center px-6 pt-5">
          {steps.map((step, index) => {
            const isActive = index === activeStepIndex;
            const isComplete = index < activeStepIndex;
            return (
              <div key={step.key} className="flex flex-1 items-center last:flex-none">
                <div className="flex items-center gap-2">
                  <div
                    className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-xs font-semibold transition-colors ${
                      isActive
                        ? "text-white shadow-sm"
                        : isComplete
                        ? "bg-[#6BC698] text-white"
                        : "bg-gray-100 text-gray-400"
                    }`}
                    style={
                      isActive
                        ? {
                            backgroundImage:
                              "linear-gradient(177.88deg, #AFD462 1.79%, #6BC698 49.97%, #0FB1E2 82.06%)",
                          }
                        : undefined
                    }
                  >
                    {index + 1}
                  </div>
                  <span
                    className={`hidden text-xs font-medium sm:block ${
                      isActive ? "text-gray-900" : "text-gray-400"
                    }`}
                  >
                    {step.label}
                  </span>
                </div>
                {index < steps.length - 1 && (
                  <div
                    className={`mx-3 h-0.5 flex-1 rounded-full ${
                      isComplete ? "bg-[#6BC698]" : "bg-gray-100"
                    }`}
                  />
                )}
              </div>
            );
          })}
        </div>
        )}

        {/* Feedback Components */}
        <div className="flex-1 space-y-6 overflow-y-auto px-6 py-6">
          {curfback === "Feedback01" ? (
            <Feedback01
              customer={props.customer}
              setcurrfback={setcurrfback}
              next={hasQuestions ? "Feedback02" : "Feedback03"}
              showCustomerNo={props.showCustomerNo}
            />
          ) : curfback === "Feedback02" && hasQuestions ? (
            <Feedback02
              answers={FBdata.answers}
              setcurrfback={setcurrfback}
              setFBdata={setFBdata}
              questions={questionArray}
              next="Feedback03"
              back="Feedback01"
            />
          ) : curfback === "History" ? (
            <FeedbackHistory
              campaignCustomerId={FBdata?.customer_id || props.customer?.id}
            />
          ) : (
            <Feedback03
              fbanswer={FBdata.fbanswer}
              submitData={submitData}
              FBdata={FBdata}
              setcurrfback={setcurrfback}
              setFBdata={setFBdata}
              feedback={props?.camp_data?.feedBackLabels || props?.camp_data?.labels || []}
              back={hasQuestions ? "Feedback02" : "Feedback01"}
              editfbpermission={editfbpermission}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default React.memo(CallFeedback);
